import script from "./ProjectFormFirstStepV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectFormFirstStepV2.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectFormFirstStepV2.vue?vue&type=style&index=0&id=db5dbef4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db5dbef4"]])

export default __exports__